
<sidebar-layout-item
  class="cmp-contact-form-additional"
  :class="{ ['in-edit']: inEdit }"
>
  <q-form ref="form" novalidate @submit.prevent>
    <template v-if="usecase === CF_USECASE.SERVER">
      <h5>
        {{ $t('scf.additional.title') }}
        <div v-if="!inEdit" class="float-right">
          <ws-edit
            name="edit"
            class="float-right"
            :small="mobile"
            @click="$emit('edit')"
          />
          <ws-tooltip>{{ $t('general.edit') }}</ws-tooltip>
        </div>
      </h5>

      <small>{{ $t('scf.additional.info') }}</small>

      <h6 class="q-mt-4xl q-mb-md">
        {{ $t('scf.name.title') }}
      </h6>
      <ws-input
        v-model="model.name"
        :disable="!inEdit"
        :placeholder="$t('scf.name.placeholder')"
        :label="$t('scf.name.label')"
        :restrict="serverNameValidation.restriction"
        debounce="300"
        lazy-rules
        :rules="[required, ...serverNameValidation.rules, uniqueServerName]"
        @input="reEmit"
      />
      <!-- <p v-else class="text-ws-base150">
        {{ model.name }}
      </p> -->

      <hr class="ws-default q-my-xl" />

      <h6 :class="desktop ? 'q-mb-lg' : 'q-mb-md'">
        {{ $t('product.properties.monitoring.title') }}
      </h6>

      <property-radio
        v-model="model.monitoring"
        path="product.properties.monitoring"
        :in-edit="inEdit"
        :options="productOptions.monitoring"
        :period="model.period"
        :no-spacing-x="false"
        :no-spacing-y="false"
        @input="reEmit"
      />

      <hr class="ws-default q-my-xl" />

      <h6 :class="desktop ? 'q-mb-lg' : 'q-mb-md'">
        {{ $t('product.properties.ip_address.title') }}
      </h6>

      <property-radio
        v-model="model.ipAddress"
        path="product.properties.ip_address"
        :in-edit="inEdit"
        :options="productOptions.ipAddress"
        :period="model.period"
        :no-spacing-x="false"
        :no-spacing-y="false"
        @input="reEmit"
      />

      <hr class="ws-default q-my-xl" />

      <property-os
        v-model="model.os"
        :in-edit="inEdit"
        :options="productOptions.os"
        :licences.sync="model.licences"
        @input="reEmit"
        @update:licences="reEmit"
      />

      <template v-if="productOptions.backup">
        <hr class="ws-default q-my-xl" />

        <h6 :class="desktop ? 'q-mb-lg' : 'q-mb-md'">
          {{ $t('scf.additional_services.title') }}
        </h6>

        <property-slider
          v-model="model.backup"
          label="product.properties.backup.title"
          :in-edit="inEdit"
          @input="reEmit"
        />
      </template>
    </template>

    <!-- Currently just CF_USECASE.MONITORING -->
    <template v-else>
      <h5>
        {{ $t(`scf.${usecase}.additional.title`) }}
        <div v-if="!inEdit">
          <ws-edit
            v-if="!inEdit"
            name="edit"
            class="float-right"
            :small="mobile"
            @click="$emit('edit')"
          />
          <ws-tooltip>{{ $t('general.edit') }}</ws-tooltip>
        </div>
      </h5>

      <small v-if="inEdit || hasSelected.any" class="inline-block q-mb-4xl">
        {{ $t(`scf.${usecase}.additional.info`) }}
      </small>
      <ws-message
        v-else
        class="non-selected q-mt-md"
        banner
        type="gray"
        icon="info"
        :messages="`scf.${usecase}.additional.non_selected_info`"
      />

      <div v-for="(section, index) in productOptions" :key="section.name">
        <template v-if="inEdit || hasSelected[section.name]">
          <hr v-if="index" class="ws-default q-my-xl" />

          <h6
            v-if="section.name !== 'general'"
            :class="desktop ? 'q-mb-lg' : 'q-mb-md'"
          >
            {{ $t(getKey(section.name, 'title')) }}
          </h6>

          <ws-checkbox-list
            v-model="model"
            uid-prop="name"
            mode="item"
            :show-selected-only="!inEdit"
            :in-edit="inEdit"
            :items="section.options"
            :columns="section.name === 'general' ? 1 : 2"
            @input="reEmit"
          >
            <template v-slot="scope">
              <small class="text-ws-base150">{{
                $t(getPropsKey(section.name, scope.item.name, 'label'))
              }}</small>
            </template>
            <!--
            TODO: $te method does not work
            <div
              v-if="$te(getPropsKey(section.name, scope.item.name, 'info'))"
            > -->
            <template v-slot:info="scope">
              <small
                v-if="
                  !$t(getPropsKey(section.name, scope.item.name, 'info'), {
                    _silent: true,
                  }).startsWith('product.properties.')
                "
                class="q-mt-sm"
              >
                {{ $t(getPropsKey(section.name, scope.item.name, 'info')) }}
              </small>
            </template>
          </ws-checkbox-list>
        </template>
      </div>
    </template>
    <div
      v-if="inEdit"
      class="full-width text-center buttons-wrap relative-position"
    >
      <ws-back v-if="!mobile" class="absolute-left" :url="backUrl" />
      <ws-button submit :type="WsButtonEnum.Type.PRIMARY" :disable="loading" @click="submit">
        {{ $t('scf.additional_services.save_btn') }}
      </ws-button>
      <ws-back
        v-if="mobile"
        class="full-width q-mt-lg q-pr-sm"
        :url="backUrl"
      />
    </div>
  </q-form>
</sidebar-layout-item>
